export default "__VITE_ASSET__DLOC0HLN__"